import { isHidden } from "app/common/services/pageClaims";
import type { SWSettings } from "app/common/services/swSettings";
import { EFamilyTypes } from "app/components/dashboard/dashboard-templates/components/DashboardTemplatesTypes";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export const AdvertiserPerformanceOvertime = {
    id: "AdvertiserPerformanceOvertime",
    properties: {
        dashboard: "true",
        metric: "AdvertiserPerformanceOvertime",
        hasWebSource: true,
        title: "ad.intelligence.advertiser.overview.performance.over.time.widget.title",
        order: "1",
        family: EFamilyTypes.Advertiser,
        component: "AdIntelligence",
        endpoint: "api/adIntelligence/advertiser",
        state: "adintelligence.root.frame.advertisersOverview",
        viewPermissions: {
            trafficSources: [devicesTypes.TOTAL],
        },
        isHidden: (swSettings: SWSettings) => isHidden(swSettings.components.AdIntelligence),
        webSource: devicesTypes.TOTAL,
        noCompare: true,
    },
    widgets: {
        single: {
            AdIntelligencePerformanceOvertimeGraph: {
                properties: {},
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Spend",
                    type: "long",
                    format: "abbrNumber",
                    formatParameter: 0,
                    name: "Spend",
                    reversed: "False",
                    tickAmount: 4,
                },
                filters: {},
            },
        },
    },
};

export const PublisherPerformanceOvertime = {
    id: "PublisherPerformanceOvertime",
    properties: {
        dashboard: "true",
        metric: "PublisherPerformanceOvertime",
        hasWebSource: true,
        title: "ad.intelligence.publisher.overview.performance.over.time.widget.title",
        order: "1",
        family: EFamilyTypes.Publisher,
        component: "AdIntelligence",
        endpoint: "api/adIntelligence/publisher",
        state: "adintelligence.root.frame.publishersOverview",
        viewPermissions: {
            trafficSources: [devicesTypes.TOTAL],
        },
        isHidden: (swSettings: SWSettings) => isHidden(swSettings.components.AdIntelligence),
        webSource: devicesTypes.TOTAL,
        noCompare: true,
    },
    widgets: {
        single: {
            AdIntelligencePerformanceOvertimeGraph: {
                properties: {},
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Spend",
                    type: "long",
                    format: "abbrNumber",
                    formatParameter: 0,
                    name: "Spend",
                    reversed: "False",
                    tickAmount: 4,
                },
                filters: {},
            },
        },
    },
};
